
import { round_to_01, round_to_10 } from "../../functions.ts";
import { useStore } from "../../state/state.ts";
import InfoButton from "../inputs/info-button.tsx";
import Statistics from "../statistics.tsx";
import ModalInfoEnergieverbrauch from "../../modals/modal_info_energieverbrauch.tsx";

export default function StatisticsEnergieverbrauch() {
  const _heizung = useStore((state)=>state.heizung);
  const _verbrauchseinheit_oel = useStore((state)=>state.verbrauchseinheit_oel);
  const _verbrauchseinheit_gas = useStore((state)=>state.verbrauchseinheit_gas);
  const _verbrauchseinheit_holz = useStore((state)=>state.verbrauchseinheit_holz);
  const _verbrauchseinheit_andere = useStore((state)=>state.verbrauchseinheit_andere);

  const annual_energy_consumption_kwh_adjusted = useStore((state)=>state.annual_energy_consumption_kwh_adjusted || 0);
  const annual_energy_consumption_kwh_planned = useStore((state)=>state.annual_energy_consumption_kwh_planned || 0);

  const unit_to_kwh_current = useStore((state)=>state.unit_to_kwh_current);
  const get_selected_unit_label_current = useStore((state)=>state.get_selected_unit_label_current);

  let energy_consumption_now = round_to_10(unit_to_kwh_current(annual_energy_consumption_kwh_adjusted));
  let energy_consumption_future = round_to_10(unit_to_kwh_current(annual_energy_consumption_kwh_planned));
  let unit = get_selected_unit_label_current()+"/Jahr";

    // switch (heizung) {
    //   case "heating_system_current_0":
    //   case "heating_system_current_8":
    //   case "heating_system_current_10":
    //     // oelverbrauch
    //     //if (verbrauchseinheit_oel == "liter"){
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted * 0.1);
    //       energy_consumption_future=round_to_10(annual_energy_consumption_kwh_planned * 0.1);
    //       unit="l/Jahr";
    //     //}
    //     break;
    //   case "heating_system_current_1":
    //   case "heating_system_current_7":
    //   case "heating_system_current_9":
    //     // gasverbrauch
    //     if (verbrauchseinheit_gas == "m3"){
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted / 3120);
    //       energy_consumption_future=round_to_10(annual_energy_consumption_kwh_planned / 3120); 
    //       unit="m³/Jahr";
    //     }else{
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted);
    //       energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned); 
    //       unit="kwh/Jahr";
    //     }
    //     break;
    //   case "heating_system_current_2":
    //     // holzverbrauch
    //     if (verbrauchseinheit_holz == "kg"){
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted / 4.8);
    //       energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned / 4.8); 
    //       unit="kg/Jahr";
    //     }else if ((verbrauchseinheit_holz == "t")) {
    //       energy_consumption_now = round_to_01(annual_energy_consumption_kwh_adjusted / 4800);
    //       energy_consumption_future = round_to_01(annual_energy_consumption_kwh_planned / 4800); 
    //       unit="t/Jahr";
    //     }else if ((verbrauchseinheit_holz == "m3")) {
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted / 3120);
    //       energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned / 3120); 
    //       unit="m³/Jahr";
    //     }
    //     break;
    //   case "heating_system_current_3":
    //   case "heating_system_current_4":
    //   default:
    //       // stromverbrauchwaermepumpe
    //       energy_consumption_now = round_to_10(annual_energy_consumption_kwh_adjusted);
    //       energy_consumption_future = round_to_10(annual_energy_consumption_kwh_planned); 
    //       unit="kwh/Jahr";
    //       break;
    // }

    return <>
    <Statistics label="Energieverbrauch" now={energy_consumption_now} future={energy_consumption_future} unit={unit} >
      <InfoButton label="Energieverbrauch" modal={<ModalInfoEnergieverbrauch/>}/>
    </Statistics>
    
    </>

}